import createReducer from 'utils/createReducer';

const CLEAR_STATE = 'journeyHistoricalRoutes/CLEAR_STATE';
const SET_LOADING = 'journeyHistoricalRoutes/SET_LOADING';
const SET_ROUTES = 'journeyHistoricalRoutes/SET_ROUTES';
const SET_ERROR = 'journeyHistoricalRoutes/SET_ERROR';

// Initial State
const INIT_STATE = {
  loading: true,
  error: null,
  routes: [],
};

// Reducers
export default createReducer(INIT_STATE, {
  [CLEAR_STATE](state) {
    return {
      ...state,
      loading: true,
      routes: [],
      error: null,
    };
  },
  [SET_LOADING](state, loading) {
    return {
      ...state,
      loading,
    };
  },
  [SET_ROUTES](state, routes) {
    return {
      ...state,
      routes,
    };
  },
  [SET_ERROR](state, error) {
    return {
      ...state,
      error,
    };
  },
});

export const clearState = () => ({
  type: CLEAR_STATE,
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setRoutes = (routes) => ({
  type: SET_ROUTES,
  payload: routes,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});
